// extracted by mini-css-extract-plugin
export default {"content-box":"App_content-box_t3otd","content-box-header":"App_content-box-header_BKE9R","loader":"App_loader_ppCPw","loading":"App_loading_Wd4An"};